import React, { useEffect, Suspense } from 'react';
import { Card, Button } from 'react-bootstrap';
import { EmrVendorService } from '../../services';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCheck, faPen, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons';
import { useImmer } from 'use-immer';
import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import UpsertEmrVendorModal from '../../controls/modals/UpsertEmrVendorModal';

const EmrVendors = (props) => {
    const [vendors, setVendors] = useImmer([]);
    const [canCreate, setCanCreate] = useImmer(false);

    const authContext = useContext(AuthContext);

    useEffect(() => {
        const values = [authContext.claimValues.createReadUpdateDelete];
        const canCreate = authContext.hasPermission(authContext.claims.canCrudEmrVendors, values);
        setCanCreate(canCreate);
        getVendors();
    }, [])

    const getVendors = async () => {
        var vendorService = new EmrVendorService();
        var callResult = await vendorService.getVendors();
        if (callResult.result) {
            setVendors(callResult.model);
        }
    }

    const renderVendorTable = () => {
        return (
            <table className='table table-striped table-hover overflow-auto' aria-labelledby="tabelLabel">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th className="table-fit"></th>
                    </tr>
                </thead>
                <tbody className="overflow-auto">
                    {vendors?.map((vendor) =>
                        <tr key={vendor.id}>
                            <td>{vendor.name}</td>
                            <td className="table-fit">
                                <FontAwesomeIcon icon={faChevronCircleRight}
                                    className="secondary-icon givemethefinger"
                                onClick={() => authContext.showModal({
                                    open: true,
                                    model: { id: vendor.id},
                                    hideModal: authContext.hideModal,
                                    updateVendors: getVendors
                                }, 'upsertEmrVendor')}                                />
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        );
    }

    return (
        <Card>
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto">Emr Vendors</div>
                <div className="card-btn-group">
                    <Button
                        variant="primary"
                        style={!canCreate ? { display: "none" } : null}
                        size="sm"
                        onClick={() => authContext.showModal({
                            open: true,
                            hideModal: authContext.hideModal,
                            updateVendors: getVendors
                        }, 'upsertEmrVendor')}>
                        Create
                    </Button>
                </div>
            </Card.Header>
            <Card.Body className="card-body-table">
                { renderVendorTable() }
            </Card.Body>
        </Card>
    );
}

export default EmrVendors;

//class EmrVendors extends Component {
//    constructor(props, context) {
//        super(props, context);
//        this.state = { vendors: [] };
//    }

//    componentDidMount() {
//        this.getVendors();
//    }

//    async getVendors() {
//        var vendorService = new EmrVendorService();
//        var results = await vendorService.getVendors();
//        this.setState({ vendors: results.model });
//    }

//    renderVendorTable() {
//        return (
//            <table className='table table-striped table-hover overflow-auto' aria-labelledby="tabelLabel">
//                <thead>
//                <tr>
//                    <th>Name</th>
//                    <th className="table-fit"></th>
//                </tr>
//                </thead>
//                <tbody className="overflow-auto">
//                {this.state.vendors.map((account) =>
//                        <tr key={account.id}>
//                            <td>{account.name}</td>
//                            <td className="table-fit">
//                                <FontAwesomeIcon icon={faChevronCircleRight} className="secondary-icon" />
//                            </td>
//                        </tr>
//                    )}
//                </tbody>
//            </table>
//        );
//    }

//    render() {
//        return (
//            <Card>
//                <Card.Header className="d-flex align-items-center">
//                    <div className="mr-auto" >Vendors</div>
//                    <div className="card-btn-group">
//                        {
//                        //<Button variant="primary" size="sm">Create New</Button>
//                        //    <Button variant="success" size="sm">Create New</Button>
//                        }
//                    </div>
//                </Card.Header>
//                <Card.Body className="card-body-table">
//                    {
//                        this.renderVendorTable()
//                        //this.state.viewModel.accounts.map((account) =>
//                        //    <div>{account.id} - {account.name} - {account.emrVendor} - {account.state}</div>
//                        //)
//                    }
//                </Card.Body>
//            </Card>
//        );
//    }

//}